import { Gender } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { emptyStringToNull, pageParam, pageSizeParam } from '../_shared/coerce.js';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
export const updateClientSchema = z.object({
    email: emptyStringToNull(z.string().email()),
    firstName: personName({ optional: true }),
    lastName: personName({ optional: true }),
    secondaryEmail: emptyStringToNull(z.string().email()),
    address: emptyStringToNull(z.string()),
    birthDate: emptyStringToNull(isoDateString()),
    city: emptyStringToNull(z.string()),
    gender: z.nativeEnum(Gender).optional(),
    note: emptyStringToNull(z.string()),
    postalCode: emptyStringToNull(z.string()),
});
export const adminUpdateClientEmailSchema = z.object({
    email: z
        .string()
        .min(1, "L'adresse email est requise.")
        .email('Veuillez saisir une adresse email valide.'),
});
export const adminUpdateClientPasswordSchema = z.object({
    password: z.string().min(8),
    passwordConfirmation: z.string().min(8),
});
export const getClientsQuerySchema = z.object({
    page: pageParam(),
    pageSize: pageSizeParam(),
    search: z.string().optional(),
});
